__turbopack_context__.v({
  "textIsTranslating": "paN6tq_textIsTranslating",
});
